module.exports = __webpack_public_path__ + "static/7-Tap-europos-egzamino-ambasadoriumi-bf59ae51c82c00e6f1d14be3ff6b8461.svg";